import { FC } from 'react';
import clsx from 'clsx';
import { Icon } from '@kontentino/ui';
import { CreateOption } from 'components/navigation/verticalNavigation/mainMenu/createTooltipContent/CreateTooltipContent';

type Props = {
  option: CreateOption;
};

const FeaturedCreateOption: FC<Props> = ({ option }) => {
  return (
    <div
      onClick={option.onClick}
      data-name={`posts-add-new-${option.key}`}
      className={clsx(
        'tw-group tw-flex tw-cursor-pointer tw-flex-col tw-gap-2 tw-rounded-lg tw-bg-grayscale-10 tw-p-4 tw-transition-colors hover:tw-bg-primary-10',
        {
          '!tw-bg-primary-10': option.highlighted,
        },
      )}
    >
      <div className="tw-flex tw-items-center tw-gap-3">
        <Icon
          icon={option.icon}
          className={clsx(
            'tw-text-grayscale-100 group-hover:tw-text-primary-100',
            {
              'tw-text-primary-100': option.highlighted,
            },
          )}
          size="lg"
        />
        <span
          className={clsx(
            'tw-text-md tw-font-medium tw-text-grayscale-180 group-hover:tw-text-primary-100',
            {
              '!tw-text-primary-100': option.highlighted,
            },
          )}
        >
          {option.label}
        </span>
      </div>
      {option.description && (
        <p
          className={clsx(
            'tw-text-sm tw-text-grayscale-180 group-hover:tw-text-primary-100',
            {
              '!tw-text-primary-100': option.highlighted,
            },
          )}
        >
          {option.description}
        </p>
      )}
    </div>
  );
};

export default FeaturedCreateOption;
